<template>
	<v-row justify="center">
		<v-col cols="12" sm="10" md="7" class="caption text-left text--secondary">
			Compartir con otras personas
			<v-card-text class="text-left pb-1 pointer" @click="helpShare = !helpShare">
				<div style="width: max-content;">
					<v-icon small color="primary">mdi-help-rhombus</v-icon>
					<span style="font-size: 12px;">¿Qué es compartir con otras personas?</span>
				</div>
			</v-card-text>
			<v-expand-transition>
				<div v-if="helpShare" class="pointer" @click="helpShare = !helpShare">
					<DataEmpty
						:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
						font-color="#6A31FF"
						height="170"
						title="¿Para qué sirve?"
						msj="Primero debes tener un correo registrado en sistema e ingresarlo en el formulario de abajo. Al realizar esta acción, el usuario de este correo podrá ver y manejar todos tus lugares y personas. En futuras versiones, este sistema tendrá mayor funcionalidad"
					/>
					<br />
					<DataEmpty
						:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
						font-color="#6A31FF"
						height="170"
						title="Dejar de compartir"
						msj="Presionando la X del chip, cancelas toda la compartición con el usuario. También el usuario puede cancelar individualmente elementos compartidos. Esto no quiere decir que se eliminarán. Para refrescar datos nuevos, sólo debes eliminar y volver a agregar el correo."
					/>
				</div>
			</v-expand-transition>
		</v-col>

		<v-col cols="12" sm="10" md="7">
			<SharingForm></SharingForm>
		</v-col>
		<v-col cols="12" sm="10" md="7">
			<UserSharingChips :data="userEmails" :withme="sharingWithMeEmails" />
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'UserSharingCard',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		SharingForm: () => import('@/components/user/SharingForm'),
		// eslint-disable-next-line vue/no-unused-components
		UserSharingChips: () => import('@/components/user/UserSharingChips'),
	},
	props: {
		userEmails: { type: Array, required: true },
	},
	data() {
		return {
			helpShare: false,
		};
	},
	computed: {
		...mapGetters({
			sharingWithMeEmails: 'User/sharingWithMeEmails',
			profile: 'User/profile',
		}),
	},
	mounted() {},
	methods: {
		...mapActions({
			sharePlaceAndPersons: 'User/sharePlaceAndPersons',
			updatePassword: 'User/updatePassword',
			removeShareWithUser: 'User/removeShareWithUser',
		}),
	},
};
</script>

<style scoped></style>
